module.exports = __webpack_public_path__ + "img/continue_the_quiz.1e54e3f2.svg";